export default {"src":"/_next/static/media/debtcalc.20cf59e3.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};